import { IBaseFilterParameter, BaseFilterParameter } from '../base-filter.parameter';

export interface IBlockParameter extends IBaseFilterParameter {
  city?: string;
  key?: string;
  entity?: string[] | number[];
  managed_by?: string;
  has_child?:boolean
}

export class BlockParameter extends BaseFilterParameter {
  city?: string;
  managed_by?: string;
  key?: string;
  entity: string[] | number[];
  has_child?:boolean

  constructor(partial: Partial<IBlockParameter> = {}) {
    super({ state: partial.state });
    Object.assign(this, partial);
  }
}



// WEBPACK FOOTER //
// ./src/models/block/block.parameter.ts